import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import PublicLayout from "@/components/public/PublicLayout";
import ScrollToTop from "@/components/public/ScrollToTop";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ResidentialPage from "@/pages/Residential";
import ProjectDetailPage from "@/pages/ProjectDetail";
import BimPage from "@/pages/Bim";
import ContactPage from "@/pages/Contact";
import PrivacyPolicyPage from "@/pages/PrivacyPolicy";
import CookiePolicyPage from "@/pages/CookiePolicy";
import NotFoundPage from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminLeads from "@/pages/admin/Leads";
import AdminPagesModule from "@/pages/admin/Pages";
import AdminProjects from "@/pages/admin/Projects";
import AdminProjectEdit from "@/pages/admin/ProjectEdit";
import AdminTestimonials from "@/pages/admin/Testimonials";
import AdminTeam from "@/pages/admin/Team";
import AdminServices from "@/pages/admin/Services";
import AdminMedia from "@/pages/admin/Media";
import AdminSettings from "@/pages/admin/Settings";
import AdminActivity from "@/pages/admin/Activity";
import AdminSeo from "@/pages/admin/Seo";

import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-ink-black text-brand-white dark">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/residential-design" element={<ResidentialPage />} />
            <Route
              path="/residential-design/:slug"
              element={<ProjectDetailPage />}
            />
            <Route path="/bim-production" element={<BimPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          {/* Admin routes (hidden, not linked publicly) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="pages" element={<AdminPagesModule />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="projects/:slug" element={<AdminProjectEdit />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="seo" element={<AdminSeo />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="activity" element={<AdminActivity />} />
          </Route>
        </Routes>

        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#111",
              color: "#FAFAFA",
              border: "1px solid #26262a",
              fontFamily: "'Objective','Manrope','Inter',sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
